import React from 'react';
import PropTypes from 'prop-types';
const win = (typeof window !== 'undefined' ? (window as any) : undefined) as any;
if (win) {
    win.React = win.React || React;
    win.global = win.global || win;
    win.PropTypes = win.PropTypes || PropTypes;
    if (!win.process) {
        win.process = { env: { NODE_ENV: process.env.NODE_ENV } };
    }
}
